var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"assist-product-title",class:`${_vm.colorClass} ${_vm.largeTitle ? 'large' : ''} ${_vm.componentClass}`},[_c('span',[_vm._v(_vm._s(_vm.coloredText))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.normalText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }